var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticStyle: { left: "0px!important" },
      attrs: {
        "offset-y": _vm.$vuetify.breakpoint.mdAndUp,
        "close-on-content-click": false,
        "max-height": "100%",
        "max-width": _vm.max_width,
        transition: "fade-transition"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "menu-trigger",
                    attrs: { flat: "", icon: "" }
                  },
                  on
                ),
                [
                  _vm.show
                    ? _c("v-icon", { attrs: { large: "" } }, [_vm._v("close")])
                    : _c("v-icon", { attrs: { large: "" } }, [_vm._v("menu")])
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm._v(" "),
      _c("v-card", { staticClass: "card-menu" }, [
        _c("div", {
          directives: [
            {
              name: "shortkey",
              rawName: "v-shortkey",
              value: ["esc"],
              expression: "['esc']"
            }
          ],
          on: {
            shortkey: function($event) {
              _vm.show = false
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "menu-topbar" }, [
          _c("div", { staticClass: "user-block" }, [
            _c(
              "div",
              { staticClass: "user-avatar" },
              [_c("v-icon", { staticClass: "user-icon" }, [_vm._v("person")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "user-info" }, [
              _c("span", { staticClass: "user-label" }, [
                _vm._v("Connecté en tant que")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "user-name" }, [
                _vm._v(_vm._s(_vm.user.name))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "topbar-actions" },
            [
              _vm._l(_vm.about_pages, function(about_page) {
                return _c(
                  "router-link",
                  {
                    key: about_page.name,
                    staticClass: "topbar-link",
                    style: { color: about_page.color },
                    attrs: { to: about_page.link_to, title: about_page.name },
                    nativeOn: {
                      click: function($event) {
                        _vm.show = false
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { color: about_page.color } }, [
                      _vm._v(_vm._s(about_page.icon))
                    ])
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.admin_pages, function(admin_page) {
                return _vm.is_admin
                  ? _c(
                      "router-link",
                      {
                        key: admin_page.name,
                        staticClass: "topbar-link topbar-link--admin",
                        attrs: {
                          to: admin_page.link_to,
                          title: admin_page.name
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.show = false
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: admin_page.color } }, [
                          _vm._v(_vm._s(admin_page.icon))
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("span", { staticClass: "topbar-divider" }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "topbar-btn topbar-btn--logout",
                  attrs: { title: "Déconnexion" },
                  on: {
                    click: function($event) {
                      return _vm.signOut()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("power_settings_new")])],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "topbar-btn",
                  attrs: { title: "Fermer le menu" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menu-body" }, [
          _c(
            "div",
            { staticClass: "menu-columns" },
            _vm._l(_vm.menus, function(menu, i) {
              return _c(
                "div",
                { key: "menu" + i, staticClass: "nav-column" },
                [
                  _c(
                    "div",
                    { staticClass: "nav-header" },
                    [
                      _c("v-icon", { staticClass: "nav-header-icon" }, [
                        _vm._v(_vm._s(menu.icon))
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t\t" + _vm._s(menu.name) + "\n\t\t\t\t\t"
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(menu.children, function(child, j) {
                    return _c(
                      "router-link",
                      {
                        key: "child" + j,
                        staticClass: "nav-item",
                        attrs: {
                          to: child.link_to,
                          title: child.description || child.name
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.show = false
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "nav-item-text" }, [
                          _vm._v(_vm._s(child.name))
                        ]),
                        _vm._v(" "),
                        child.is_new
                          ? _c("span", { staticClass: "badge-new" }, [
                              _vm._v("new")
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              )
            }),
            0
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79c63194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c63194","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/App_menu.vue
// module id = null
// module chunks = 